interface HamburgerIconProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

export default function HamburgerIcon({
  isOpen,
  onClick,
  className = "",
}: HamburgerIconProps) {
  return (
    <button
      onClick={onClick}
      className={`z-50 hover:bg-gray-100 h-8 desktop:h-auto transition-colors shrink-0 w-10 min-w-[52px] relative after:content-[''] after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:h-[24px] after:w-[1px] after:bg-white after:border-l after:border-[#ccc] px-0 desktop:pl-12 desktop:pr-[70px] ${className}`}
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      <div className="w-6 h-6 relative flex items-center justify-center">
        {/* Top line */}
        <span
          className={`absolute block w-6 h-0.5 bg-dominos-blue rounded-full transition-all duration-300 ease-in-out ${
            isOpen ? "rotate-45" : "-translate-y-2"
          }`}
        />
        {/* Middle line */}
        <span
          className={`absolute block w-6 h-0.5 bg-dominos-blue rounded-full transition-all duration-300 ease-in-out ${
            isOpen ? "opacity-0 scale-0" : "opacity-100 scale-100"
          }`}
        />
        {/* Bottom line */}
        <span
          className={`absolute block w-6 h-0.5 bg-dominos-blue rounded-full transition-all duration-300 ease-in-out ${
            isOpen ? "-rotate-45" : "translate-y-2"
          }`}
        />
      </div>
    </button>
  );
}
